module.exports = __webpack_public_path__ + "static/media/secure.91eb2212.svg";